<div class="data-card__footer__previous-period" *ngIf="!isLoading">
  <div>
    <span class="data-card__footer__previous-period-label"> {{ 'DATA_CARD.PREVIOUS_PERIOD' | translate }}: </span>
    <span class="data-card__footer__previous-period-value">
      {{ data }}
    </span>
  </div>
  <div
    *ngIf="previous !== current && previous !== 0"
    class="data-card__footer__previous-period-percent"
    [ngClass]="previous > current ? 'decreased' : 'increased'"
  >
    <mat-icon inline>
      {{ previous > current ? 'south' : 'north' }}
    </mat-icon>
    {{ percentage | percent }}
  </div>
</div>

<div class="data-card__footer__previous-period" *ngIf="isLoading" fxLayoutAlign="center center">
  <ngx-skeleton-loader [theme]="{ height: '14px', width: '100px', margin: 'auto' }"></ngx-skeleton-loader>
</div>
